import type { SVGProps } from 'react';

export function ParachuteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M14.718 1.858C9.116.357 3.358 3.68 1.858 9.282c-.17.632.187 1.208.743 1.457a.54.54 0 0 1 .217.166l4.67 6.347-.715 2.665a1.5 1.5 0 0 0 1.06 1.837l2.898.776a1.5 1.5 0 0 0 1.838-1.06l.714-2.666 7.216-3.161a.54.54 0 0 1 .271-.036c.606.063 1.203-.258 1.372-.89 1.501-5.6-1.823-11.358-7.424-12.86m-3.921 10.288a.44.44 0 0 0-.197-.493c-1.486-.888-3.013-1.384-4.625-1.35-.344.007-.514.397-.31.674l3.55 4.828c.066.088.16.149.266.177q.135.037.268.073zm7.358 2.067c.31-.136.362-.55.072-.725-1.23-.74-2.818-1.085-4.844-1.06a.44.44 0 0 0-.42.33l-1.04 3.88c.143.038.289.072.43.117z"
        clipRule="evenodd"
      />
    </svg>
  );
}
